<template>
  <div class="b-menu-pagination-actions-prev">
    <div class="b-menu-pagination-actions-prev__button" :class="classes" :title="title" @click="onClick">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
      </svg>
    </div>
  </div>
</template>

<script>
import StoreHelper from '../store/helper'
import _ from 'lodash'

export default {
  name: 'b-menu-pagination-actions-prev',
  methods: {
    onClick () { this.$emit('click') }
  },
  computed: {
    classes () {
      return _.get(StoreHelper.getPaginationPrevButtonConfig(), 'classes', [])
    },
    title () {
      return _.get(StoreHelper.getPaginationPrevButtonConfig(), 'title', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.b-menu-pagination-actions-prev {
  height: 100%;
  width: 100%;

  &__button {
    height: 100%;
    width: 100%;
    background-color: #D3D3D3;
    border-radius: 50%;
    cursor: pointer;
  }

  svg {
    fill: white;
    height: 100%;
    width: 100%;
    padding-right: 5%;
  }
}
</style>
